module.exports = __webpack_public_path__ + "media/Ciclones.40e34090.mp4";